import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './masonryfireplaces.css'; // Import the CSS file for styling

const MasonryFireplaces = () => {
  const images = [
  "/images/Masonry and Fireplace/Fireplace_01.jpg",
"/images/Masonry and Fireplace/Fireplace_02.jpg",
"/images/Masonry and Fireplace/Fireplace_03.jpg",
"/images/Masonry and Fireplace/Fireplace_04.jpg",
"/images/Masonry and Fireplace/Fireplace_05.jpg",
"/images/Masonry and Fireplace/Fireplace_06.jpg",
"/images/Masonry and Fireplace/Fireplace_07.jpg",
"/images/Masonry and Fireplace/Fireplace_08.jpg",
"/images/Masonry and Fireplace/Fireplace_09.jpg",
"/images/Masonry and Fireplace/Fireplace_10.jpg",
"/images/Masonry and Fireplace/Fireplace_11.jpg",
"/images/Masonry and Fireplace/Fireplace_12.jpg",
"/images/Masonry and Fireplace/Fireplace_13.jpg",
"/images/Masonry and Fireplace/Fireplace_14.jpg",
"/images/Masonry and Fireplace/Fireplace_15.jpg",
"/images/Masonry and Fireplace/Fireplace_16.jpg",
"/images/Masonry and Fireplace/Fireplace_17.jpg",
"/images/Masonry and Fireplace/Fireplace_18.jpg",
"/images/Masonry and Fireplace/Fireplace_19.jpg",
"/images/Masonry and Fireplace/Fireplace_20.jpg"

  ];

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Function to go to the next image
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to go to the previous image
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Auto change image every 6 seconds
  useEffect(() => {
    const interval = setInterval(nextImage, 6000);
    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  return (
    <div className="masonryfireplaces-container">
      <Link to="/" className="home-button">Home</Link> {/* Home button */}
      
      <div className="image-frame">
        <div className="text-container">
          <h2><div className="title-gc">Masonry & Fireplaces</div></h2>
          <p><div className="text-blurb">
            Traditional Line specializes in the restoration and installation of masonry and fireplace features. 
            Our work includes historic masonry restoration, fireplace installation, and custom masonry detailing.
          </div></p>
        </div>

        <div className="slideshow-container">
          <img
            src={images[currentImageIndex]}
            alt={`Masonry Fireplace Slide ${currentImageIndex}`}
            className="masonryfireplaces-image"
          />
          {/* Navigation buttons */}
          <button className="prev-button" onClick={prevImage}>❮</button>
          <button className="next-button" onClick={nextImage}>❯</button>
        </div>
      </div>
    </div>
  );
};

export default MasonryFireplaces;
